// This file should only be used by the ViewerCountService
import { create } from 'zustand';
const useViewerCountOutput = create(() => ({
    viewerCountForActiveBroadcast: undefined,
}));
const reactiveOutput = {
    useViewerCountForActiveBroadcast: () => {
        return useViewerCountOutput((s) => s.viewerCountForActiveBroadcast);
    },
};
// This class should only be used by the ViewerCountService
export class ViewerCountServiceOutput {
    static getReactiveOutput() {
        return reactiveOutput;
    }
    setViewerForActiveBroadcast(value) {
        useViewerCountOutput.setState({ viewerCountForActiveBroadcast: value });
    }
}
